/* 特价车
const routerConfig = {
  baseUrl: '/410/2020/specialcar/',
  router: [
    {
      path: '/cloudcars',
      name: 'CloudCars',
      component: resolve => require(['@/pages/BMW-Topic/Index.vue'], resolve),
    }
  ]
}
// */


/* 宝马专题*/
// const routerConfig = {
//   baseUrl: '/topic/seecargroup/baoma/',
//   router: [
//     {
//       path: '/bmwtopic',
//       name: 'BMWTopic',
//       component: resolve => require(['@/pages/BMW-Topic/Index.vue'], resolve),
//     }
//   ]
// }
//


/* 818预热
const routerConfig = {
 baseUrl: '/618/2020/specialcar/',
 router: [
   {
     path: '/warmup818',
     name: 'WarmUp818',
     component: resolve => require(['@/pages/warmup818/index'], resolve),
   },
   {
     path: '/policy',
     name: 'Policy',
     component: resolve => require(['@/pages/warmup818/policy'], resolve),
   }
 ]
}
*/

// 1112 正式专题
// const routerConfig = {
//   // baseUrl: '/topic/',
//   baseUrl: '/TopicApp/2020/1112/',
//   router: [
//     {
//       path: '/topic',
//       name: '1112Topic',
//       component: resolve => require(['@/pages/2020-1112/index'], resolve),
//     },
//     {
//       path:'/activepop',
//       name:'1112Role',
//       component:resolve => require(['@/pages/2020-1112/ActivePop'], resolve)
//     }
//   ]
// }


/* 特价车长期活动落地页
const routerConfig = {
 // baseUrl: '/topic/',
 baseUrl: '/TopicApp/2020/0826/',
 router: [
   {
     path: '/SpecialCar',
     name: 'SpecialCar',
     component: resolve => require(['@/pages/SpecialCar0826/index'], resolve),
   },
   {
     path: '/rules',
     name: 'rules',
     component: resolve => require(['@/pages/SpecialCar0826/rules'], resolve),
   }
 ]
}

// /* 一元小订专题页
const routerConfig = {
 // baseUrl: '/topic/',
 baseUrl: '/TopicApp/2020/0825/',
 router: [
   {
     path: '/OneYuan',
     name: 'OneYuan',
     component: resolve => require(['@/pages/OneYuan0825/index'], resolve),
   }
 ]
}
//*/

/* 邀卖车活动页
const routerConfig = {
  baseUrl: '/TopicApp/2020/invitation/',
  router: [
    {
      path: '/shareindex',
      name: 'ShareIndex',
      component: resolve => require(['@/pages/InvitationSaleCar/ShareIndex'], resolve),
    },
    {
      path: '/salecar',
      name: 'SaleCar',
      component: resolve => require(['@/pages/InvitationSaleCar/SaleCar'], resolve),
    },
    {
      path: '/success',
      name: 'Success',
      component: resolve => require(['@/pages/InvitationSaleCar/Success'], resolve),
    }
  ]
}
// */

/* 车商圈专题
const routerConfig = {
  baseUrl: '/TopicApp/2020/businessdistrict/',
  router: [
    {
      path: '/BusinessDistrict',
      name: 'BusinessDistrict',
      component: resolve => require(['@/pages/BusinessDistrict/index'], resolve),
    },
    {
      path: '/pc',
      name: 'pc',
      component: resolve => require(['@/pages/BusinessDistrict/pc'], resolve),
    }
  ]
}
// */

//* 兜底卖车
// const routerConfig = {
//   baseUrl: '/TopicApp/2020/salecarbottom/',
//   router: [
//     {
//       path: '/index',
//       name: 'Index',
//       component: resolve => require(['@/pages/SaleCarBottom/Index'], resolve),
//       meta: {
//         title: '兜底卖车'
//       }
//     },
//     {
//       path: '/result',
//       name: 'Result',
//       component: resolve => require(['@/pages/SaleCarBottom/Result'], resolve),
//       meta: {
//         title: '兜底卖车'
//       }
//     },
//     {
//       path: '/agreement',
//       name: 'Agreement',
//       component: resolve => require(['@/pages/SaleCarBottom/Agreement'], resolve),
//       meta: {
//         title: '兜底卖车服务协议'
//       }
//     }
//   ]
// }
/* 兜底卖车
const routerConfig = {
  baseUrl: '/TopicApp/2020/salecarbottom/',
  router: [
    {
      path: '/index',
      name: 'Index',
      component: resolve => require(['@/pages/SaleCarBottom/Index'], resolve),
      meta: {
        title: '兜底卖车'
      }
    },
    {
      path: '/result',
      name: 'Result',
      component: resolve => require(['@/pages/SaleCarBottom/Result'], resolve),
      meta: {
        title: '兜底卖车'
      }
    },
    {
      path: '/agreement',
      name: 'Agreement',
      component: resolve => require(['@/pages/SaleCarBottom/Agreement'], resolve),
      meta: {
        title: '兜底卖车服务协议'
      }
    }
  ]
}
// */

/* 宝马专题
const routerConfig = {
  // baseUrl: '/topic/seecargroup/baoma',
  baseUrl: '/topic/seecargroup/baoma/202010/bmwtopic/',
  router: [
    {
      path: '/',
      name: 'Index',
      component: resolve => require(['@/pages/bmwtopic20201021/Index'], resolve),
      meta: {
        title: '宝马专题'
      }
    }
  ]
}
//  */

//* 【app】车主急售卖车页
// const routerConfig = {
//   baseUrl: '/TopicApp/2020/ownersemergencysale/',
//   router: [
//     {
//       path: '/index',
//       name: 'Index',
//       component: resolve => require(['@/pages/ownersEmergencySale/Index'], resolve),
//       meta: {
//         title: '我要卖车'
//       }
//     },
//     {
//         path: '/result',
//         name: 'Result',
//         component: resolve => require(['@/pages/ownersEmergencySale/Result'], resolve),
//         meta: {
//           title: '卖车详情'
//         }
//       },
//   ]
// }
// */


//* B2B-4S
// const routerConfig = {
//   baseUrl: '/TopicApp/2020/b2b4s/',
//   router: [
//     {
//       path: '/index',
//       name: 'Index',
//       component: resolve => require(['@/pages/B2B-4S/Index'], resolve),
//       meta: {
//         title: '商家招募'
//       }
//     },
//     {
//       path: '/share',
//       name: 'Share',
//       component: resolve => require(['@/pages/B2B-4S/SharePage'], resolve),
//       meta: {
//         title: '商家招募'
//       }
//     },{
//         path: '/inapptopic',
//         name: 'TopicShow',
//         component: resolve => require(['@/pages/B2B-4S/TopicShow'], resolve),
//         meta: {
//           title: '商家招募'
//         }
//     }
//   ]
// }
//*/

//* 【PC/M】商户注册引导页
const routerConfig = {
  baseUrl: '/TopicApp/2020/businessregistrationguide/',
  router: [
    {
      path: '/pc',
      name: 'pc',
      component: resolve => require(['@/pages/BusinessRegistrationGuide/pc'], resolve),
      meta: {
        title: '商户注册引导页'
      }
    },
    {
        path: '/m',
        name: 'm',
        component: resolve => require(['@/pages/BusinessRegistrationGuide/m'], resolve),
        meta: {
          title: '商户注册引导页'
        }
      },
  ]
}
// */
//路由和baseURL 配置
export default routerConfig;


// WEBPACK FOOTER //
// ./src/router/routerConfig.js